module.exports = __webpack_public_path__ + "static/ing-design-f2d56398969e4e8451a98df7672c64b5.jpg";